import { Injectable } from '@angular/core';

@Injectable()
export class SourceService {

  sourceSlots = [];


  constructor() {
  }


  getSourceSlots() {
    return this.sourceSlots;
  }


  addToSourceSlots(source) {
    if (this.sourceSlots.length >= 5) {
      console.log('too many MMs');
      return;
    }

    console.log('copy MM', source);
    this.sourceSlots.push(source);
  }


  getSourceSlotToPaste(numSourceSlot) {
    const sourceToPaste = this.sourceSlots.splice(numSourceSlot -1, 1)[0];
    delete sourceToPaste._id;

    console.log('paste MM', sourceToPaste);
    return sourceToPaste;
  }

  hasSourceSlot(numSourceSlot) {
    return this.sourceSlots.length >= numSourceSlot;
  }
}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/source.service.ts